// extracted by mini-css-extract-plugin
module.exports = {"toolCard":"Index_toolCard__ZOvAi","toolImg":"Index_toolImg__My3kP"};